import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5493708f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5493708f')) {
      api.createRecord('5493708f', component.options)
    } else {
      api.reload('5493708f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5493708f&", function () {
      api.rerender('5493708f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/offershelp.vue"
export default component.exports